export const localization = {
  pt: {
    title: 'Importar arquivo',
    subtitle:
      'Importe manuais, guias e artigos para criar uma base de conhecimento para seu agente.',
    fileUpload: {
      title: 'Importar arquivos',
      subtitle: 'Você pode enviar arquivos nos formatos XLSX, CSV, PDF, TXT, DOCX e PPTX',
    },
    preProcessBanner:
      'O pré-processamento aumenta o consumo de tokens e o tempo de sincronização. Recomendado para projetos que exigem maior precisão e refinamento no tratamento dos dados.',
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successImportFilesToast: {
      title: 'Conteúdo adicionado',
      message: 'O conteúdo foi salvo e está em sincronização. Ele ficará disponível no catálogo em instantes.',
    },
    errorImportFilesToast: {
      title: 'Falha ao adicionar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
      messageWithFiles: 'Não foi possível enviar os seguintes arquivos: {files}',
    },
    successUpdateFileToast: {
      title: 'Conteúdo atualizado',
      message: 'O conteúdo foi salvo e está em sincronização. Ele ficará disponível no catálogo em instantes.',
    },
    errorUpdateFileToast: {
      title: 'Falha ao atualizar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
    },
  },
  en: {
    title: 'Import file',
    subtitle:
      'Import manuals, guides, and articles to create a knowledge base for your agent.',
    fileUpload: {
      title: 'Import files',
      subtitle: 'You can upload files in XLSX, CSV, PDF, TXT, DOCX and PPTX formats',
    },
    preProcessBanner:
      'Pre-processing increases token consumption and synchronization time. Recommended for projects that require greater precision and refinement in data processing.',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    successImportFilesToast: {
      title: 'Content added',
      message: 'The content has been saved and is syncing. It will be available in the catalog shortly.',
    },
    errorImportFilesToast: {
      title: 'Could not add content',
      message: 'Could not save the content. Please try again.',
      messageWithFiles: 'Could not upload the following files: {files}',
    },
    successUpdateFileToast: {
      title: 'Content updated',
      message: 'The content has been saved and is syncing. It will be available in the catalog shortly.',
    },
    errorUpdateFileToast: {
      title: 'Could not update content',
      message: 'Could not save the content. Please try again.',
    },
  },
  es: {
    title: 'Importar archivo',
    subtitle:
      'Importa manuales, guías y artículos para crear una base de conocimiento para tu agente.',
    fileUpload: {
      title: 'Importar archivos',
      subtitle: 'Puedes enviar archivos en formatos XLSX, CSV, PDF, TXT, DOCX y PPTX',
    },
    preProcessBanner:
      'El preprocesamiento aumenta el consumo de tokens y el tiempo de sincronización. Recomendado para proyectos que requieren mayor precisión y refinamiento en el tratamiento de datos.',
    cancelButton: 'Cancelar',
    saveButton: 'Guardar',
    successImportFilesToast: {
      title: 'Contenido agregado',
      message: 'El contenido se ha guardado y está en sincronización. Estará disponible en el catálogo en breve.',
    },
    errorImportFilesToast: {
      title: 'No se pudo agregar el contenido',
      message: 'No se pudo guardar el contenido. Por favor, inténtalo de nuevo.',
      messageWithFiles: 'No se pudieron subir los siguientes archivos: {files}',
    },
    successUpdateFileToast: {
      title: 'Contenido actualizado',
      message: 'El contenido se ha guardado y está en sincronización. Estará disponible en el catálogo en breve.',
    },
    errorUpdateFileToast: {
      title: 'No se pudo actualizar el contenido',
      message: 'No se pudo guardar el contenido. Por favor, inténtalo de nuevo.',
    },
  },
};
